import { IFlyerDetailState } from "../types/flyer-detail-state/flyer-detail-state.interface";
import { FlyerDetailActions, FlyerDetailActionType } from "./flyer-detail.actions";
import { createFlyerDetailState } from "../types/flyer-detail-state/flyer-detail-state.functions";
import { LOADING_STATES } from "../../../../../features/loading";
import { flyerDetailPageReducer } from "../pages/flyer-detail-page/store/flyer-detail-page.reducer";
import { FlyerDetailPageActionType } from "../pages/flyer-detail-page/store/flyer-detail-page.actions";
import { FlyerDetailAddPageActionType } from "../pages/flyer-detail-add-page/store/flyer-detail-add-page.actions";
import { flyerDetailAddPageReducer } from "../pages/flyer-detail-add-page/store/flyer-detail-add-page.reducer";

export function flyerDetailReducer(
  state = createFlyerDetailState(),
  action: FlyerDetailActionType
): IFlyerDetailState {
  switch (action.type) {
    case FlyerDetailActions.ClearErrors:
      return {
        ...state,
        errors: null,
      };
    case FlyerDetailActions.Fetch:
      return {
        ...state,
        errors: null,
        flyer: null,
        loading: LOADING_STATES.loading,
      };
    case FlyerDetailActions.FetchFailure:
      return {
        ...state,
        errors: action.payload,
        flyer: null,
        loading: LOADING_STATES.failed,
      };
    case FlyerDetailActions.FetchSuccess:
    case FlyerDetailActions.SaveSuccess:
    case FlyerDetailActions.SetFlyer:
      return {
        ...state,
        errors: null,
        flyer: action.payload,
        loading: LOADING_STATES.loaded,
        saving: false,
      };
    case FlyerDetailActions.Save:
      return {
        ...state,
        loading: LOADING_STATES.loading,
        saving: true,
      };
    case FlyerDetailActions.SaveFailure:
      const errorType = action.payload?.status === 400 ? "formErrors" : "errors";
      return {
        ...state,
        loading: LOADING_STATES.loaded,
        saving: false,
        [errorType]: action.payload,
      };
    case FlyerDetailActions.DeletePage:
      return {
        ...state,
        loading: LOADING_STATES.loading,
      };
    case FlyerDetailActions.DeletePageSuccess:
      return {
        ...state,
        loading: LOADING_STATES.loaded,
      };
    case FlyerDetailActions.ResetState:
      return createFlyerDetailState();
    default:
      return {
        ...state,
        flyerDetailPageState: flyerDetailPageReducer(
          state.flyerDetailPageState,
          action as FlyerDetailPageActionType
        ),
        flyerDetailAddPageState: flyerDetailAddPageReducer(
          state.flyerDetailAddPageState,
          action as FlyerDetailAddPageActionType
        ),
      };
  }
}
